import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { useDeviceType } from '../../../../responsive';
import { ETooltipViewType } from '../../types';
export function useTooltipViewType(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose;
  var deviceType = useDeviceType();
  var _React$useState = React.useState(getViewType(deviceType)),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    viewType = _React$useState2[0],
    setViewType = _React$useState2[1];

  /**
   * getDerivedStateFromProps
   *
   * https://ru.reactjs.org/docs/hooks-faq.html#how-do-i-implement-getderivedstatefromprops
   */
  var nextViewType = getViewType(deviceType);
  if (viewType !== nextViewType) {
    if (open) {
      onClose();
    }
    setViewType(nextViewType);
  }
  return viewType;
}
function getViewType(deviceType) {
  if (deviceType === 'phone') {
    return ETooltipViewType.Modal;
  }
  return ETooltipViewType.Popper;
}